import type { FotoPaginationDTO } from '@/models/dto/plc/foto-pagination-dto'
import type { PhotosWithPagination } from '@/models/types/plc/photos-with-pagination'
import { mapToPagination, mapToPaginationDTO } from '../pagination-mapper'
import { mapToFotoDTO, mapToPhoto } from './photo-mapper'

const mapToPhotosWithPagination = (dto: FotoPaginationDTO): PhotosWithPagination => {
    return {
        photos: dto.foto.map(mapToPhoto),
        pagination: mapToPagination(dto.paginationData),
    }
}

const mapToFotoPaginationDTO = (photosWithPagination: PhotosWithPagination): FotoPaginationDTO => {
    return {
        foto: photosWithPagination.photos.map(mapToFotoDTO),
        paginationData: mapToPaginationDTO(photosWithPagination.pagination),
    }
}

export { mapToFotoPaginationDTO, mapToPhotosWithPagination }
